






























import { Component, Mixins } from "vue-property-decorator";
import { CommentTableMixin } from "./mixins";

@Component({})
export default class CommentWideTable extends Mixins(CommentTableMixin) {
}
